import { render, staticRenderFns } from "./EditReview.vue?vue&type=template&id=2a6608ad&scoped=true&"
import script from "./EditReview.vue?vue&type=script&lang=js&"
export * from "./EditReview.vue?vue&type=script&lang=js&"
import style0 from "./EditReview.vue?vue&type=style&index=0&id=2a6608ad&prod&scoped=true&lang=css&"
import style1 from "./EditReview.vue?vue&type=style&index=1&id=2a6608ad&prod&lang=css&"
import style2 from "./EditReview.vue?vue&type=style&index=2&id=2a6608ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6608ad",
  null
  
)

export default component.exports